import Vue from 'vue'
import { mutateAll } from '@/store/utils'
import { createInitialState } from './index'

export const setUserHasOrcasAccess = (state, hasOrcasAccess): void => {
  Vue.set(state, 'hasOrcasAccess', hasOrcasAccess)
}

export const addPasswordLinkExpirationStatus = (state, payload): void => {
  const newState = { ...state, ...payload }
  mutateAll(state, newState)
}

export const setPasswordLinkSendingState = (state, payload): void => {
  Vue.set(state, 'passwordLinkIsSending', payload)
}

export const setNewPasswordSubmittingState = (state, payload): void => {
  Vue.set(state, 'newPasswordIsSubmitting', payload)
}

export const setTokenValidityState = (state, payload): void => {
  Vue.set(state, 'tokenIsValid', payload)
}

export const reset = (state): void => {
  mutateAll(state, createInitialState())
}

export const setCookieSelection = (state, { key, selected }): void => {
  const arrayWithoutKey = state.selectedCookies.filter(value => value !== key)
  Vue.set(
    state,
    'selectedCookies',
    selected ? arrayWithoutKey.concat([key]) : arrayWithoutKey
  )
}
